import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'modules/shared/shared.module';

import { CustomersRoutingModule } from './customers-routing.module';

import { CustomerAccessControlPage } from './pages/customer-access-control/customer-access-control.page';
import { CustomerEditPage } from './pages/customer-edit/customer-edit.page';
import { CustomerOnboardingPage } from './pages/customer-onboarding/customer-onboarding.page';
import { CustomerRelationshipMapPage } from './pages/customer-relationship-map/customer-relationship-map.page';
import { CustomerOverviewPage } from './pages/customer-overview/customer-overview.page';
import { CustomersListPage } from './pages/customers-list/customers-list.page';
import { CrpEditPage } from './pages/crp-edit/crp-edit.page';
import { CrpAddPage } from './pages/crp-add/crp-add.page';
import { CustomersBatchUploadPage } from './pages/customers-batch-upload/customers-batch-upload.page';

import { DetailsFormComponent } from './components/details-form/details-form.component';
import { MultipleValuesInputComponent } from './components/details-form/multiple-values-input/multiple-values-input.component';
import { CrpListCardComponent } from './components/crp-list-card/crp-list-card.component';
import { CrpRoleComponent } from './components/crp-role/crp-role.component';
import { CustomerDocumentComponent } from './components/customer-document/customer-document.component';
import { CustomerDocumentListComponent } from './components/customer-document-list/customer-document-list.component';
import { CustomerOtherDataComponent } from './components/customer-other-data/customer-other-data.component';
import { CustomersBatchUploadHistoryComponent } from './components/customers-batch-upload-history/customers-batch-upload-history.component';
import { CustomersBatchUploadComponent } from './components/customers-batch-upload/customers-batch-upload.component';

@NgModule({
  declarations: [
    CustomerDocumentComponent,
    DetailsFormComponent,
    MultipleValuesInputComponent,
    CustomerDocumentListComponent,
    CrpListCardComponent,
    CrpRoleComponent,
    CustomerOtherDataComponent,

    CustomerAccessControlPage,
    CustomerEditPage,
    CustomerOnboardingPage,
    CustomerRelationshipMapPage,
    CustomerOverviewPage,
    CustomersListPage,
    CrpAddPage,
    CrpEditPage,
    CustomersBatchUploadPage,
    CustomersBatchUploadHistoryComponent,
    CustomersBatchUploadComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    SharedModule,

    CustomersRoutingModule
  ]
})
export class CustomersModule { }
